import { HttpBadStatusCodeError, TPrimitives } from '@cian/peperrors/shared';
import {
  fetchGetOffersHistoryExists,
 TGetOffersHistoryExistsResponse
} from '../../../repositories/valuation-offer-history/v1/get-offers-history-exists';
import { IThunkContext } from '../../../types/redux';

interface IFetchOffersHistoryExistsParams {
  offerId?: number;
  houseId?: number;
}

export async function fetchOffersHistoryExists(context: IThunkContext, parameters: IFetchOffersHistoryExistsParams) {
  const { httpApi, logger } = context;

  try {
    const res = (await fetchGetOffersHistoryExists({
      httpApi,
      parameters,
    })) as TGetOffersHistoryExistsResponse;

    if (res.statusCode !== 200) {
      throw new HttpBadStatusCodeError({
        statusCode: 400,
        message: res.response.message as string,
        domain: 'fetchGetOffersHistoryExists',
        details: {
          errors: res.response.errors as unknown as TPrimitives[],
          ...parameters,
        },
      });
    }

    return res.response.exists;
  } catch (error) {
    if (error instanceof HttpBadStatusCodeError) {
      logger.warning('offers-history-exists BadRequest', { details: error.printDetails() });
    } else {
      logger.error(error, { message: 'Error in offers-history-exists', ...parameters });
    }

    throw error;
  }
}
